
import React, { Component, Fragment } from 'react'
import DropItemUI from './DropItemUI'
import DropItem from '../model/DropItem'


class DropItemContainerUI extends Component {

    render = () => {

        let { activity, quizViewer } = this.props
        let { dropItemList } = activity.dropItemContainer
        let {selectedStyle}=activity.dropItemContainer
        // console.log(dropItemList)
        return (
            <Fragment>

                <div
                 //style={(selectedStyle!=null)?selectedStyle[0].style:{}}
                 >


                    {
                      this.getDropItemList()
                    }
                </div>
            </Fragment>
        )
    }


    getDropItemList = () => {

        let { activity, quizViewer } = this.props
        let { dropItemList } = activity.dropItemContainer

        return (
            <Fragment>
                {
                    dropItemList.map((dropItem, index) => {
                        return (
                            <DropItemUI key={index}
                                dropItem={dropItem}
                                activity={activity}
                                quizViewer={quizViewer}
                            />
                        )

                    })
                }
            </Fragment>
        )

    }


    handleAddDropItem = () => {
        let { activity, quizViewer } = this.props
        let { dropItemContainer } = activity
        let dropItem = new DropItem();
        dropItemContainer.addDropItem(dropItem)
        quizViewer.setState({});
    }
}

export default DropItemContainerUI